import { AppwriteConfig } from "@prism/prism-shared";

export const appwriteConfigStaging: AppwriteConfig = {
    domain: '',
    endpoint: '',
    projectId: '',
    databaseId: '',
    siteId: '',
};

export const appwriteConfigTesting: AppwriteConfig = {
    domain: 'seljan-testing.com',
    endpoint: 'https://data.seljan-testing.com/v1',
    projectId: 'seljan-fishbowl',
    databaseId: '69f3b9650039fbeea5a7',
    siteId: '69f397fd0037e673381f'
};

export const appwriteConfigProduction: AppwriteConfig = {
    domain: 'seljan-fishbowl.com',
    endpoint: 'https://data.seljan-fishbowl.com/v1',
    projectId: '6a0226240026284b66f1',
    databaseId: '6a02265b0033afad3c2d',
    siteId: '6a0239a0002d35e2cf86',
};
